var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn light ps-sm-0 ps-md-5 ms-0 ms-xl-3",attrs:{"type":"button","id":"back"},on:{"click":function($event){return _vm.$router.back()}}},[_c('span',{staticClass:"back-icon"},[_vm._v("◂ ")]),_vm._v(" Ortga ")])}
var staticRenderFns = []

export { render, staticRenderFns }